import _sfc_main from "./BuyBox2.mjs";
/* empty css         */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBox = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-a7db5379"]]);
export {
  BuyBox as default
};
//# sourceMappingURL=BuyBox.mjs.map
